import { render, staticRenderFns } from "./BlogLastMile.vue?vue&type=template&id=33d41a3e&scoped=true&"
import script from "./BlogLastMile.vue?vue&type=script&lang=js&"
export * from "./BlogLastMile.vue?vue&type=script&lang=js&"
import style0 from "./BlogLastMile.vue?vue&type=style&index=0&id=33d41a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d41a3e",
  null
  
)

export default component.exports